/**
 * This file provides shared Perseus feature flag configuration for all applications.
 * If individual applications require different feature flag configurations, they should
 * copy this file to their respective application directory (apps/*) and customize as needed.
 */
import type {GrowthBook} from "@growthbook/growthbook-react";

import {PerseusFeatureFlags} from "@khanacademy/perseus-core";

import type {APIOptions} from "./perseus.ts";

const isOn = (feature: string, features?: GrowthBook<Record<string, any>>) =>
    features?.isOn(feature) ?? false;

/**
 * Builds the set of feature flags for Perseus' APIOptions based on Growthbook.
 * Automatically syncs with Perseus core feature flags - no manual updates needed.
 *
 * The list of active flags is maintained in the Perseus repository:
 * https://github.com/Khan/perseus/blob/main/packages/perseus-core/src/feature-flags.ts
 */
export function flagsForApiOptions(
    features?: GrowthBook<Record<string, any>>,
): APIOptions["flags"] {
    return Object.fromEntries(
        PerseusFeatureFlags.map((flag) => [flag, isOn(flag, features)]),
    ) as APIOptions["flags"];
}
